import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=3774c3e2&scoped=true&"
import script from "./Appeals.vue?vue&type=script&lang=js&"
export * from "./Appeals.vue?vue&type=script&lang=js&"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=3774c3e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774c3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
